(function TripSummaryScheduleComponentDay($, Adzuki)
{
	'use strict';

	const component = {
		emits: [
			'addImagesToComponent',
			'delete',
			'deleteComponentImage',
			'edit',
			'hideUnhideComponent',
			'hideUnhideComponentVendor',
			'moveComponent',
			'setComponentMainImage',
			'updateComponentCruiseDayImage',
			'updateComponentDescription',
			'updateComponentTravelers',
		],
		inject: [
			'getFaIconStyle',
			'formatDate',
			'formatTime',
		],
		props: {
			sectionMode: {
				type   : Boolean,
				default: false,
			},
			currentDay: {
				type   : Object,
				default: {},
			},
			dayNumber: {
				type   : Number,
				default: 1,
			},
			fitBuilderId: {
				type   : String,
				default: 'new',
			},
			fitBuilderTypeId: {
				type   : Number,
				default: 1,
			},
			itinerary: {
				type    : Object,
				required: false,
				default : {},
			},
			oneWayCounts: {
				type   : Map,
				default: new Map(),
			},
			summaryTravelers: {
				type    : Array,
				required: true,
			},
		},
		template: '#ts-schedule-component-day',
		data() {
			return {
				// component id -> collapsed, reported by each ts-schedule-component
				collapsedById: {},
			};
		},
		computed: {
			// true only when every component on this day is collapsed, so the
			// chevron offers "Expand all" exactly when there is nothing left to
			// collapse -- whether that came from this chevron, the per-component
			// chevrons or the Compact / Expanded view switch
			dayCollapsed() {
				const components = this.currentDay.components || [];

				return components.length > 0 && components.every(component => this.collapsedById[component.id] === true);
			},
			currentDayComponents() {
				const components = this.currentDay.components || [];

				// copy before sorting: sort() is in-place, and this array is shared
				// with ts-schedule-day, so sorting here would mutate reactive state
				// during render. The comparator must return 0 for equal sort_order,
				// otherwise it is inconsistent and the order is unstable.
				return components.slice().sort((a, b) => {
					let aOrder = a.sort_order || 0;
					let bOrder = b.sort_order || 0;

					return aOrder - bOrder;
				});
			},
			// TS-421: in Sections mode a section's date is its own components' dates
			// -- one date, a range, or none -- never a stored day date, which the
			// Days logic spread across sections one day apart
			headerDate() {
				if (!this.sectionMode) {
					return this.currentDay.date ? this.formatDate(this.currentDay.date) : 'No date';
				}

				const dates = (this.currentDay.components || [])
					.map((component) => (component.date ? String(component.date).slice(0, 10) : null))
					.filter((date) => date)
					.sort();

				if (!dates.length) {
					return '';
				}

				const first = dates[0];
				const last  = dates[dates.length - 1];

				return (first === last)
					? this.formatDate(first)
					: moment(first).format('MMM D') + ' – ' + moment(last).format('MMM D');
			},
			containerNoun() {
				return this.sectionMode ? 'Section' : 'Day';
			},
			dayLabel() {
				return this.currentDay.label || `${this.containerNoun} ${this.dayNumber}`;
			},
		},
		methods: {
			addImagesToComponent(eventData) {
				this.$emit('addImagesToComponent', eventData);
			},
			deleteComponent(component) {
				this.$emit('delete', component);
			},
			deleteComponentImage(imageId) {
				this.$emit('deleteComponentImage', imageId);
			},
			// passes the optional tab through (TS-364)
			editComponent(component, tab) {
				this.$emit('edit', component, tab);
			},
			hideUnhideComponent(component, hide) {
				this.$emit('hideUnhideComponent', component, hide);
			},
			hideUnhideComponentVendor(component, hide) {
				this.$emit('hideUnhideComponentVendor', component, hide);
			},
			moveComponent(eventData) {
				this.$emit('moveComponent', eventData);
			},
			setComponentMainImage(image) {
				this.$emit('setComponentMainImage', image);
			},
			setComponentCollapsed(componentId, collapsed) {
				this.collapsedById[componentId] = collapsed;
			},
			toggleDayCollapsed(event) {
				// The chevron keeps focus after the click, and focus alone keeps its tooltip
				// open. Hide it and blur. The wording itself comes from the bound
				// data-bs-original-title, which is the attribute Bootstrap 5 reads, so the
				// next hover always shows the current Expand/Collapse text. (Not dispose():
				// it copies the old text back into title, which the next hover re-reads.)
				if (event && event.currentTarget) {
					$(event.currentTarget).tooltip('hide');
					event.currentTarget.blur();
				}

				const compact = !this.dayCollapsed;

				// ts-schedule-component instances on this day listen for this
				document.dispatchEvent(new CustomEvent('ts-compact-day', {
					detail: {
						dayNumber: this.dayNumber,
						compact  : compact,
					},
				}));
			},
			updateComponentCruiseDayImage(eventData) {
				this.$emit('updateComponentCruiseDayImage', eventData);
			},
			updateComponentDescription(eventData) {
				this.$emit('updateComponentDescription', eventData);
			},
			updateComponentTravelers(eventData) {
				this.$emit('updateComponentTravelers', eventData);
			},
		},
	};

	Adzuki.VueComponents.TripSummaryScheduleComponentDay = component;
}(jQuery, window.Adzuki || {}));
